// Theme Presets

const lightTheme = {
    name: "light",
    body_color: "#FFFFFF",
    text_color: "#000000",
    contrast_color : "#000000",

    dark: "#000000",
    accentColor: "#6C63FF",
    skinColor: "#F7B799",

    projectCard: "#DCE4F2",
    imageDark: "#dce4f2",
    imageClothes: "#dce4f2",
    avatarMisc: "#e9ecf2",
    avatarShoes: "#ccd2e3",
    
  };
  
  const darkTheme = {
    name: "dark",
    body_color: "#1D1D1D",
    text_color: "#FFFFFF",
    contrast_color : "#FFFFFF",

    dark: "#000000",
    accentColor: "#6C63FF",
    skinColor: "#F7B799",

    projectCard: "#292A2D",
    imageDark: "#292A2D",
    imageClothes: "#000000",
    avatarMisc: "#212121",
    avatarShoes: "#2B2B2B",
 
  };
  
  export const themes = { light: lightTheme, dark: darkTheme };
  